import gql from "graphql-tag";

export const myProjects = gql`
  query {
    projects {
      id
      name
      active
    }
  }
`;

export const myProjectsOptions = {
  name: "myProjects",
};
